import {Component, HostListener} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  @HostListener('window:popstate', ['$event'])
  onPopState(event): void {
    console.log('Back button pressed');
    window.location.reload();
  }
}
